import { render, staticRenderFns } from "./NossaSenhoraAparecida.vue?vue&type=template&id=ca93e274&scoped=true&"
import script from "./NossaSenhoraAparecida.vue?vue&type=script&lang=js&"
export * from "./NossaSenhoraAparecida.vue?vue&type=script&lang=js&"
import style0 from "./NossaSenhoraAparecida.vue?vue&type=style&index=0&id=ca93e274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca93e274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
